import React from "react";
import "./sucesso.scss";
import { SvgIcon } from "@material-ui/core";
import moment from "moment";

class Sucesso extends React.Component {
  constructor() {
    super();
    this.state = { Welcome: true, QuestionIndex: 0 };
  }

  render() {
    let { dados } = this.props.formulario;

    return (
      <section className="container w-100">
        <div className="titulo-pagina">{dados.Nome}</div>
        <div className="informacoes-container">
          <div className="row">
            <div className="informacoes-titulo">Cliente: </div>
            <div className="informacoes-descricao">{dados.NomeCliente}</div>
          </div>
          <div className="row">
            <div className="informacoes-titulo"> Gerente: </div>
            <div className="informacoes-descricao">{dados.NomeGerente}</div>
          </div>
          <div className="row">
            <div className="informacoes-titulo">Preenchido em: </div>
            <div className="informacoes-descricao">
              {moment.utc().format("DD/MM/YYYY")}
            </div>
          </div>
        </div>
        <div className="flex-row justify-center w-100">
          <div className="sucesso-container">
            <div className="flex-col justify-center">
              <SvgIcon
                style={{
                  width: "90px",
                  height: "90px",
                  margin: "40px 0px 40px 0px",
                  alignSelf: "center",
                }}
              >
                <svg
                  width="90"
                  height="90"
                  viewBox="0 0 360 360"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M86.6667 41.1666V45C86.6616 53.9851 83.7521 62.7278 78.3723 69.9242C72.9924 77.1207 65.4304 82.3853 56.814 84.9329C48.1977 87.4805 38.9886 87.1745 30.5603 84.0607C22.132 80.9469 14.9361 75.192 10.0457 67.6544C5.15532 60.1168 2.8325 51.2002 3.42369 42.2346C4.01488 33.269 7.4884 24.7347 13.3262 17.9044C19.164 11.0742 27.0533 6.31406 35.8175 4.33391C44.5817 2.35375 53.7512 3.2597 61.9584 6.91663"
                    stroke="#1B5E20"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M86.6667 11.6666L45 53.375L32.5 40.875"
                    stroke="#1B5E20"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SvgIcon>
              <div className="sucesso-titulo">
                Formulário enviado com sucesso!
              </div>
              <div className="sucesso-descricao">
                Obrigado {dados.NomeGerente}, por preencher o {dados.Nome}, para{" "}
                {dados.NomeCliente} em{" "}
                {moment().utcOffset(0, true).format("DD/MM/YYYY HH:mm")}.
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Sucesso;
